var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4497_22365",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4497_22365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.6L14.65 11.65L10.7 9.8L14.65 7.95L16.5 4L18.35 7.95L22.3 9.8L18.35 11.65L16.5 15.6ZM30 21.65L28.45 18.35L25.15 16.8L28.45 15.25L30 11.95L31.55 15.25L34.85 16.8L31.55 18.35L30 21.65ZM6.85 25.65L5.3 22.35L2 20.8L5.3 19.25L6.85 15.95L8.4 19.25L11.7 20.8L8.4 22.35L6.85 25.65ZM8.3 41L6 38.7L21 23.7L29 31.75L43.9 15.05L46 17.1L29 36.25L21 28.3L8.3 41Z",
    fill: "#ACACAC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.a453dcd6764c689aba67c799160a8b53.svg";
export { ForwardRef as ReactComponent };